export const getOrganizationsFrag = `
    id
    name
`;

export const getOrganizationSettingsFrag = `
    id
    organizationId
    key
    data
    active
    createdAt
    updatedAt
`;
